import { useUserByIdQuery } from "../../stores/OkOkStore";
import { useTrads } from "../../contexts/trads/useTrads";

function UserCompteInfo({userId}:{userId:number}){
    const { data, error, isLoading } = useUserByIdQuery(userId.toString());
    const {translate}=useTrads();
    return (
        error ? (
            <p className="p-3 mb-2 bg-danger text-white">{translate('page_load_error')}</p>

        ) : isLoading ? (
            <p className="p-3 mb-2 bg-info text-white">{translate('page_loading')}</p>

        ) : data ? (
        <>
            {translate('profil_nom')} {data.nom}<br />
            {translate('profil_prenom')}: {data.prenom}<br />
            {translate('profil_iban')}: {data.iban}<br />
        </>
        ):null
    )
}
export default UserCompteInfo;